import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const validTabIds = ['visao-geral', 'dados-cadastrais'] as const;

export type ProfessionalOverviewTabIds = (typeof validTabIds)[number];

export const useProfessionalOverviewTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // States
  const activeTabId = searchParams.get('painel') as ProfessionalOverviewTabIds;

  // Methods
  const setActiveTab = useCallback(
    (tabId: ProfessionalOverviewTabIds) => {
      setSearchParams((params) => {
        if (!tabId || !validTabIds.includes(tabId)) {
          params.set('painel', 'visao-geral');
          return params;
        }

        params.set('painel', tabId);
        return params;
      });
    },
    [setSearchParams],
  );

  return {
    activeTabId,
    setActiveTab,
  };
};
